import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { Tooltip } from '@/components/ui/Tooltip';
import { FlaskFillIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
export const BetaBadge = ({
  className,
  tooltipContent
}: {
  className?: string;
  tooltipContent?: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <Tooltip side="top" trigger={<span className={cn(['border-[2px] border-inverse rounded-full bg-yellow-600 size-[22px] flex items-center justify-center shadow-xs z-20', className])}>
          <FlaskFillIcon fill={ICON_COLOR.inverse} width={12} height={12} />
        </span>} content={tooltipContent ?? t('common:common.betaBadge.tooltip')} data-sentry-element="Tooltip" data-sentry-component="BetaBadge" data-sentry-source-file="BetaBadge.tsx"></Tooltip>;
};
export const WithBetaBadge = ({
  children,
  className,
  align = 'right',
  tooltipContent
}: {
  children: React.ReactNode;
  className?: string;
  align?: 'right' | 'left';
  tooltipContent?: string;
}) => {
  return <div className="relative w-fit" data-sentry-component="WithBetaBadge" data-sentry-source-file="BetaBadge.tsx">
      <BetaBadge className={cn('origin-center absolute', align === 'right' ? 'right-0 top-0 -translate-y-1/3 translate-x-1/3' : 'left-0 top-0 -translate-y-1/3 -translate-x-1/3', className)} tooltipContent={tooltipContent} data-sentry-element="BetaBadge" data-sentry-source-file="BetaBadge.tsx" />

      {children}
    </div>;
};